module.exports = __webpack_public_path__ + "static/willow-square-75845ef60812d42338abf65bc1301745.jpeg";